module.exports = __webpack_public_path__ + "static/media/badum-tsss.b3a284d0.mp3";